var map = {
	"./en-uk.json": [
		1204,
		98
	],
	"./en.json": [
		1205,
		97
	],
	"./widgets/en-uk.json": [
		893,
		9
	],
	"./widgets/en.json": [
		894,
		8
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 792;
module.exports = webpackAsyncContext;